import { render, staticRenderFns } from "./AssistanceHomePage.vue?vue&type=template&id=1cb3c79c&scoped=true&lang=html&"
import script from "./AssistanceHomePage.vue?vue&type=script&lang=js&"
export * from "./AssistanceHomePage.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceHomePage.vue?vue&type=style&index=0&id=1cb3c79c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3c79c",
  null
  
)

export default component.exports